import { render, staticRenderFns } from "./Question23.vue?vue&type=template&id=f111a1da&scoped=true&"
import script from "./Question23.vue?vue&type=script&lang=js&"
export * from "./Question23.vue?vue&type=script&lang=js&"
import style0 from "./Question23.vue?vue&type=style&index=0&id=f111a1da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f111a1da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VForm,VRadio,VRadioGroup})
